import { render } from "./SpeechToText.vue?vue&type=template&id=4395042b&scoped=true"
import script from "./SpeechToText.vue?vue&type=script&lang=js"
export * from "./SpeechToText.vue?vue&type=script&lang=js"

import "./SpeechToText.vue?vue&type=style&index=0&id=4395042b&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4395042b"]])

export default __exports__